import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

export type Inputs = "empleado";
export type Buttons = "aceptar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "empleado",
      label: "Empleado",
      bts: {
        sCol: 6
      },
      component: IUserSelectorBuilder
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Buscar",
      isSubmit: true,
      bts: {
        sCol: 3
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    empleado: {
      requiredIfNotNoEmpleado: {
        validator: (value, formValue) => !formValue.noEmpleado && !value,
        message: () => "Ingrese el número de empleado o selecciónelo"
      }
    }
  },
  rows: [["empleado", "aceptar"]]
};
